import React from 'react';
import {Helmet} from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import Ct1 from '../../images/acfabric/ct1.jpg';
import Ct2 from '../../images/acfabric/ct2.jpg';
import Ct3 from '../../images/acfabric/ct3.jpg';
import Ct4 from '../../images/acfabric/ct4.jpg';
import Ct5 from '../../images/acfabric/ct5.jpg';
import Ct6 from '../../images/acfabric/ct6.jpg';
import Ct7 from '../../images/acfabric/ct7.jpg';
import Ct8 from '../../images/acfabric/ct8.jpg';
import Ct9 from '../../images/acfabric/ct9.jpg';
import './acfabric-crosstown.css';
import ScrollToTopButton from '../ScrollButton';
function acfabriccross() {
    return (
      
    <>
    <Helmet>
    <title>Acoustic of Maine Crosstown Acoustic Fabric - Acoustical Surfaces</title>
    <meta name="description" content="" />
    <meta property="og:title" content="AcoustyFABRIC Crosstown" />
    <meta property="og:description" content="Guilford of Maine Crosstown 2526 Fabric Facings" />
    <meta property="og:image" content="https://www.acousticalsurfaces.in/images/acfabric/ct1.jpg" />
    <meta property="og:locale" content="en-in" />
    <meta name="geo.placename" content="India"/>
    <meta http-equiv="content-language" content="in" />
    <meta name="geo.region" content="india" />
    <link rel="canonical" href="https://www.acousticalsurfaces.in/acfabric-crosstown" />
    <link rel="alternate" href="https://www.acousticalsurfaces.in/acfabric-crosstown" hreflang="en-in" />
    <link rel="alternate" href="https://www.acousticalsurfaces.ae/acfabric-crosstown" hreflang="en-ae" />
    </Helmet>
    <Header />
    <section className="content" id="acfabriccrosstown">
        <div className="container">
            <div className="row">
                <div className="col-sm-3 sidemenu">
                    <Sidebar />
                </div>
            	<div className="col-sm-9 product-page nopaddding">
                    <div className="container"> 
                        <div className="megamenu">
                            <Megamenu />
				        </div>
                    </div>
	                <div className="col-sm-12 heading-fsorb">				
		                <h1>Acousty<span className="fabriwall">FABRIC</span> Crosstown</h1>
                		<h4 className="mb-0"> <b>Guilford of Maine Crosstown 2526 Fabric Facings</b></h4>
		                <p><span className="color:red;">(Colors Shown are Approximate Match to Material)</span></p>
	                    <br />
		                <div className="col-sm-3 cloths p-0"><button>Product Specifications</button></div>
	                </div>
		            <br /><br />
		            <div className="col-sm-12 cloths">
		                <div className="row d-flex justify-content-center mb-2">
                        	<div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Ct1} alt="Cement 010" />
                                <p className="text-center">Cement 010</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Ct2} alt="Mystic 020" />
                                <p className="text-center">Mystic 020</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Ct3} alt="Ray 030" />
                                <p className="text-center">Ray 030</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Ct4} alt="Waterfront 040" />
                                <p className="text-center">Waterfront 040</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Ct5} alt="Chamois 050" />
                                <p className="text-center">Chamois 050</p>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center mb-2">
                        	<div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Ct6} alt="Fieldstone 060" />
                                <p className="text-center">Fieldstone 060</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Ct7} alt="Sterling 061" />
                                <p className="text-center">Sterling 061</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Ct8} alt="Stucco 070" />
                                <p className="text-center">Stucco 070</p>
                            </div>
                            <div className="col-2 col-sm-2 p-0 mx-2">
                                <img className="w-100" src={Ct9} alt="Buff 080" />
                                <p className="text-center">Buff 080</p>
                            </div>
                            <div className=" col-sm-2 p-0 mx-2"></div>
                        </div>	
            		</div>
		            <br />
		            <hr />
                    <div className="col-12 d-flex justify-content-center backbtn">
                        <Link to="/acoustyfabric"><button>Back to Acousty<span style={{color: "red"}}>FABRIC</span></button></Link>
                    </div>
                    <hr />
                    <div className="col-sm-12 application">
			            <h1>APPLICATION</h1>
	                    <div className="hover14 text-center justify-content-center">
		                <br />
  		                    <div className="col-sm-12">
			                    <figure className="m-0"><div className="tinted-image">CINEMA HALL</div></figure>
 		                    </div>
                            <br />
  		                    <div className="col-sm-12">
    	                        <figure className="m-0"><div className="tinted-image2">OFFICE ROOMS & HALLS</div></figure>
 		                    </div>
                            <br />
  		                    <div className="col-sm-12">
    	                        <figure className="m-0"><div className="tinted-image3">AUDITORIUM & EDUCATION</div></figure>
 		                    </div>
                            <br />
	                    </div>
                    </div>
		            <br />
                </div>
            </div>
            <div className='mobsidebar'>
                <div className="col-sm-12">
                    <div className="container">
                        <div className="row">
                            <Mobsidebar />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ScrollToTopButton />
    </section>
<Footer />
</>
);
}
export default acfabriccross;